import { browserSupportsWebAuthn, startAuthentication, startRegistration, type PublicKeyCredentialCreationOptionsJSON, type PublicKeyCredentialRequestOptionsJSON } from '@simplewebauthn/browser'
import { post } from './api.ts'

/** Passkeys (ADR 0019): the browser talks to the authenticator; the server keeps the challenge and the public key. */
export const passkeysSupported = () => typeof window !== 'undefined' && browserSupportsWebAuthn()

export async function registerPasskey(name: string): Promise<{ id: string; name: string }> {
  const { challengeId, options } = await post<{ challengeId: string; options: PublicKeyCredentialCreationOptionsJSON }>('/api/auth/passkeys/register/options')
  const response = await startRegistration({ optionsJSON: options })
  return post('/api/auth/passkeys/register/verify', { challengeId, name, response })
}

export async function loginWithPasskey(): Promise<{ ok: true }> {
  const { challengeId, options } = await post<{ challengeId: string; options: PublicKeyCredentialRequestOptionsJSON }>('/api/auth/passkeys/login/options')
  const response = await startAuthentication({ optionsJSON: options })
  return post('/api/auth/passkeys/login/verify', { challengeId, response })
}
